import { render, staticRenderFns } from "./SectionDetailsContent.vue?vue&type=template&id=685e02d4&scoped=true"
import script from "./SectionDetailsContent.vue?vue&type=script&lang=js"
export * from "./SectionDetailsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e02d4",
  null
  
)

export default component.exports